import { render, staticRenderFns } from "./ExpertiseLevel.vue?vue&type=template&id=b2e62f2c&scoped=true"
import script from "./ExpertiseLevel.vue?vue&type=script&lang=js"
export * from "./ExpertiseLevel.vue?vue&type=script&lang=js"
import style0 from "./ExpertiseLevel.vue?vue&type=style&index=0&id=b2e62f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e62f2c",
  null
  
)

export default component.exports